var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"intern",attrs:{"to":{ name: _vm.$attrs.name, params: { id: _vm.$attrs.id } }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }